import SeoContent from "../components/shared/SeoContent";
import FaciilitesSection from "./sections/Faciilites";

export default function FacilitiesPage() {
    return (
        <>
            <SeoContent title="Facilities" />
            <FaciilitesSection />
        </>
    );
}
